<h2>Identifications</h2>
<p-table #dt [value]="identifications" styleClass="p-datatable-striped"
    [globalFilterFields]="['identificationType','customerIdentificationValue', 'locationCode', 'effectiveDate', 'endDate', 'updatedDate', 'updatedBy']">
    <ng-template pTemplate="caption">
        <div class="row">
            <div class="col-sm-6 col-md-3">
                <input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="7">
                No records found
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Type</th>
            <th>ID Number</th>
            <th class="w--code">State/Country Code</th>
            <th>Effective Date</th>
            <th>Expiration Date</th>
            <th>Updated</th>
            <th class="td--hover-show">Updated By</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{data.identificationType}}</td>
            <td>{{!isUserLecu && isRestrictedCustomer ? '******' : data.customerIdentificationValue }}</td>
            <td>{{data.locationCode}}</td>
            <td>{{data.effectiveDate | shortDate}}</td>
            <td>{{data.endDate | shortDate}}</td>
            <td>{{data.updatedDate | dateTime}}</td>
            <td class="td--hover-show">{{data.updatedBy}}</td>
        </tr>
    </ng-template>
</p-table>